import { BrowserModule } from "@angular/platform-browser";
import { NgModule, LOCALE_ID, APP_INITIALIZER } from "@angular/core";
// import { ServiceWorkerModule } from "@angular/service-worker";
// import { environment } from "../environments/environment";
import { NgxUiLoaderConfig, NgxUiLoaderHttpModule, NgxUiLoaderModule, POSITION, SPINNER } from 'ngx-ui-loader';
import { Actions, EffectsModule, ofType } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import * as AuthActions from './store/actions/auth.actions';

// AppModules
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

// Graphics
import { MaterialModule } from "./modules/material/material.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { SharedModule } from "./modules/shared/shared.module";

// Services
import { LaravelCustomerService } from "./commons/services/laravel/laravel-customer.service";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { OrderService } from "./commons/services/order.service";

import { registerLocaleData } from "@angular/common";
import localeIt from "@angular/common/locales/it";
import { FormsModule } from "@angular/forms";
import { Action, Store, StoreModule } from "@ngrx/store";
import { environment } from "../environments/environment";
import { AppState, metaReducers, reducers } from "./store/reducers";
import { AuthEffects } from "./store/effects/auth.effects";
import { forkJoin, Observable, take } from "rxjs";
import { TokenInterceptorService } from "./helpers/token-interceptor.service";
import { TenantEffects } from "./store/effects/tanant.effects";
import { CouponsEffects } from "./store/effects/coupons.effects";
import { UsersEffects } from "./store/effects/users.effects";
import { ProductEffetcs } from "./store/effects/product.effects";
import { IngredientEffects } from "./store/effects/ingredient.effects";
import { TimeSlotsEffects } from "./store/effects/timeslots.effects"
import { ClosureEffects } from "./store/effects/closures.effects";
import { RiderEffects } from "./store/effects/riders.effects";
import { CustomersEffects } from "./store/effects/customers.effects";
import { ZonesEffects } from "./store/effects/zones.effects";
import { StatisticsEffects } from "./store/effects/statistics.effects";
import { OrdersEffects } from "./store/effects/orders.effects";
import { PopupEffects } from "./store/effects/popups.effects";
import { NotificationEffects } from "./store/effects/notifications.effects";
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import { IT_FORMATS } from "./helpers/date.helper";

registerLocaleData(localeIt, "it");

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  fgsColor: '#EE0025',
  fgsType: SPINNER.squareJellyBox,
  hasProgressBar: false,
  overlayColor: 'rgba(130,130,130,0.7)',
  fgsPosition: POSITION.bottomCenter,
};

export function initApplication(
  store: Store<AppState>,
  actions$: Actions,
): Function {
  return () =>
    new Promise((resolve) => {
      store.dispatch(AuthActions.loadCurrentUser());
      const initTasks$:Observable<Action>[] = [];
      initTasks$.push(
        actions$.pipe(ofType(
          AuthActions.loadCurrentUserCompleted,
          AuthActions.loadCurrentUserFailed
        ), take(1))
      );
      forkJoin(initTasks$).subscribe(() => resolve(true));
    });
}
@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    FormsModule,
    BrowserModule,
    AppRoutingModule,
    MaterialModule,
    BrowserAnimationsModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    NgxUiLoaderHttpModule.forRoot({
      showForeground: true,
    }),
    StoreModule.forRoot(reducers, {
      metaReducers,
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true,
      },
    }),
    EffectsModule.forRoot([
      AuthEffects,
      TenantEffects,
      CouponsEffects,
      UsersEffects,
      ProductEffetcs,
      IngredientEffects,
      TimeSlotsEffects,
      ClosureEffects,
      RiderEffects,
      CustomersEffects,
      ZonesEffects,
      StatisticsEffects,
      OrdersEffects,
      PopupEffects,
      NotificationEffects
    ]),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production,
    }),
    SharedModule
  ],
  providers: [
    AuthEffects,
    { provide: MAT_DATE_LOCALE, useValue: 'it-IT' },
    { provide: MAT_DATE_FORMATS, useValue: IT_FORMATS },
      {
        provide: LOCALE_ID,
        useValue: "it"
      },
      {
        provide: APP_INITIALIZER,
        useFactory: initApplication,
        deps: [Store, Actions],
        multi: true,
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: TokenInterceptorService,
        multi: true,
      },
    OrderService,
    //LaravelCustomerService,
    provideHttpClient(withInterceptorsFromDi())
] })
export class AppModule {}
